<div class="h-100">
  <div class="d-flex flex-column h-100">
    @if (showCallControls && callControlService.isPanelOpened && panelType === 'classic') {
      <div class="active-call-section mb-3">
        <div class="active-call-header d-flex align-items-center justify-content-between mb-2">
          <div class="d-flex align-items-center">
            <i-lucide name="phone" [size]="15" [strokeWidth]="2" class="slideout-header-icon"></i-lucide>
            <span class="slideout-header-title">Active Call</span>
          </div>
          <span class="slideout-timer">{{ callControlService.conferenceTimer }}</span>
        </div>

        <div class="participants-section mb-3">
          <div class="agent-participant d-flex align-items-center justify-content-between p-2 rounded mb-2"
            [ngClass]="{ 'is-speaking': !!callControlService.isDialerAgentSpeaking }">
            <div class="d-flex align-items-center">
              <div class="participant-avatar me-2">
                {{ callControlService.getWordsFirstLetters(callControlService.currentUserFullName) }}
              </div>
              <div>
                <div class="fw-bold small">{{ callControlService.currentUserFullName }}</div>
                <div class="text-muted small">You</div>
              </div>
            </div>
            <div class="d-flex align-items-center">
              @if (callControlService.activeConferenceExists() && !callControlService.isDialerAgentMuted) {
                <button class="call-action-btn me-1"
                  (click)="callControlService.muteDialer()" title="Mute">
                  <i-lucide name="mic" [size]="14" [strokeWidth]="2"></i-lucide>
                </button>
              }
              @if (callControlService.activeConferenceExists() && callControlService.isDialerAgentMuted) {
                <button class="call-action-btn call-action-btn--active me-1"
                  (click)="callControlService.unMuteDialer()" title="Unmute">
                  <i-lucide name="mic-off" [size]="14" [strokeWidth]="2"></i-lucide>
                </button>
              }
              @if (callControlService.activeConferenceExists()) {
                <button class="call-action-btn call-action-btn--hangup"
                  (click)="callControlService.hangUpConference()" title="End Call">
                  <i-lucide name="phone-off" [size]="14" [strokeWidth]="2"></i-lucide>
                </button>
              }
            </div>
          </div>

          @for (participant of callControlService.participants; track participant.conferenceParticipantId) {
            <div class="participant-item d-flex align-items-center justify-content-between p-2 rounded mb-2"
              [ngClass]="{ 'completed': participant.callStatus === 'Completed', 'is-speaking': !!participant.isSpeaking }">
              <div class="d-flex align-items-center">
                <div class="participant-avatar me-2">
                  {{ participant.participantFirstLetters }}
                </div>
                <div>
                  @if (participant.participantName) {
                    <div class="fw-bold small">{{ participant.participantName }}</div>
                  }
                  @if (!participant.participantName) {
                    <div class="fw-bold small">{{ participant.phoneNumber | phone }}</div>
                  }
                  @if (participant.callStatus !== 'Completed') {
                    <div class="text-muted small">
                      {{ participant.onHold ? 'On Hold' : participant.callStatus }} - {{ participant.timer }}
                    </div>
                  }
                </div>
              </div>
              @if (participant.callStatus !== 'Completed') {
                <div class="d-flex align-items-center">
                  @if (callControlService.activeConferenceExists() && participant.onHold && !participant.isAgent) {
                    <button class="call-action-btn call-action-btn--active-warning me-1"
                      (click)="callControlService.unHold(participant.conferenceParticipantId)" title="Resume">
                      <i-lucide name="play" [size]="14" [strokeWidth]="2"></i-lucide>
                    </button>
                  }
                  @if (callControlService.activeConferenceExists() && !participant.onHold && !participant.isAgent) {
                    <button class="call-action-btn me-1"
                      (click)="callControlService.hold(participant.conferenceParticipantId)" title="Hold">
                      <i-lucide name="pause" [size]="14" [strokeWidth]="2"></i-lucide>
                    </button>
                  }
                  <button class="call-action-btn call-action-btn--hangup"
                    (click)="callControlService.removeParticipantFromConference(participant.conferenceParticipantId)" title="Hang Up">
                    <i-lucide name="phone-off" [size]="14" [strokeWidth]="2"></i-lucide>
                  </button>
                </div>
              }
            </div>
          }
        </div>

        @if (!callControlService.manualDial && callControlService.selectedDialList) {
          <div class="dial-progress-section mb-3">
            <div class="d-flex align-items-center justify-content-between mb-1">
              <span class="small text-muted">Dial Progress</span>
              <span class="small fw-bold">
                {{ callControlService.selectedRecordIndex + 1 }} of {{ callControlService.selectedDialList?.records?.length }}
              </span>
            </div>
            <div class="progress" style="height: 8px;">
              <div class="progress-bar progress-bar-striped" role="progressbar"
                [ngStyle]="{
                  width: ((callControlService.selectedRecordIndex + 1) / callControlService.selectedDialList?.records?.length) * 100 + '%'
                }">
              </div>
            </div>
            <div class="d-flex justify-content-end mt-2">
              <button class="btn btn-sm btn-outline-primary me-1"
                (click)="callControlService.fetch()"
                [disabled]="callControlService.isCurrentlyDialing"
                title="Fetch">
                <i class="fas fa-sync" [ngClass]="{'fa-spin': callControlService.fetchingLead}"></i>
              </button>
              <button class="btn btn-sm btn-outline-info"
                (click)="callControlService.dialNext()"
                [disabled]="!callControlService.activeConferenceExists() || callControlService.isCurrentlyDialing || callControlService.fetchingLead"
                title="Dial Next">
                <i class="fa fa-step-forward"></i>
              </button>
            </div>
          </div>
        }

        @if (callControlService.activeConference && callControlService.participants.length && !callControlService.warmTransferStatus) {
          <div class="warm-transfer-section mb-3">
            <button class="btn btn-sm btn-outline-secondary w-100"
              [disabled]="callControlService.publishingWarmXfer"
              (click)="callControlService.publishWarmTransfer()">
              <i class="fa fa-random me-1" [hidden]="callControlService.publishingWarmXfer"></i>
              <i class="fas fa-sync fa-spin me-1" [hidden]="!callControlService.publishingWarmXfer"></i>
              Publish Warm Transfer
            </button>
          </div>
        }

        @if (callControlService.activeConference && callControlService.activeConference.agentUserId == callControlService.currentUserId && (callControlService.warmTransferStatus === 'Published' || callControlService.warmTransferStatus === 'Started')) {
          <div class="warm-transfer-actions mb-3">
            <div class="d-flex gap-2">
              <button class="btn btn-sm btn-outline-danger flex-grow-1"
                (click)="callControlService.cancelWarmTransfer()">
                <i class="fa fa-times me-1"></i> Cancel Transfer
              </button>
              @if (callControlService.warmTransferStatus === 'Started') {
                <button class="btn btn-sm btn-outline-primary flex-grow-1"
                  [disabled]="callControlService.completingWarmTransfer"
                  (click)="callControlService.completeWarmTransfer()">
                  <i class="fa fa-check me-1"></i> Complete
                </button>
              }
            </div>
          </div>
        }

        <div class="quick-actions-section">
          <div class="slideout-accordion">
            <div class="accordion-section">
              <button class="accordion-trigger" [class.expanded]="quickNotesExpanded"
                (click)="toggleQuickNotes()">
                <div class="d-flex align-items-center gap-2">
                  <i-lucide name="notebook-pen" [size]="15" [strokeWidth]="2"></i-lucide>
                  <span>Quick Notes</span>
                </div>
                <i-lucide name="chevron-down" [size]="14" [strokeWidth]="2" class="accordion-chevron" [class.rotated]="quickNotesExpanded"></i-lucide>
              </button>
              @if (quickNotesExpanded) {
                <div class="accordion-panel">
                  @if (callControlService.latestNote) {
                    <div class="latest-note">
                      <p class="mb-1">{{ callControlService.latestNote }}</p>
                      <span class="latest-note-meta">
                        {{ callControlService.latestNoteAuthor }} - {{ callControlService.latestNoteTime }}
                      </span>
                    </div>
                  }
                  <textarea class="slideout-input mb-2" rows="2" maxlength="255"
                    placeholder="Add a note... (255 char limit)"
                    [disabled]="callControlService.addingNote"
                    [(ngModel)]="callControlService.note"></textarea>
                  <button class="slideout-btn slideout-btn--primary w-100" (click)="callControlService.addNote()"
                    [disabled]="!callControlService.note?.trim() || callControlService.addingNote">
                    @if (!callControlService.addingNote) {
                      <i-lucide name="plus" [size]="14" [strokeWidth]="2.5"></i-lucide>
                      <span>Add Note</span>
                    }
                    @if (callControlService.addingNote) {
                      <i-lucide name="loader-2" [size]="14" [strokeWidth]="2" class="spin"></i-lucide>
                      <span>Adding...</span>
                    }
                  </button>
                </div>
              }
            </div>

            <div class="accordion-section">
              <button class="accordion-trigger" [class.expanded]="quickSmsExpanded"
                (click)="toggleQuickSms()">
                <div class="d-flex align-items-center gap-2">
                  <i-lucide name="message-square-text" [size]="15" [strokeWidth]="2"></i-lucide>
                  <span>Quick SMS</span>
                </div>
                <i-lucide name="chevron-down" [size]="14" [strokeWidth]="2" class="accordion-chevron" [class.rotated]="quickSmsExpanded"></i-lucide>
              </button>
              @if (quickSmsExpanded) {
                <div class="accordion-panel">
                  <form #quickSmsForm="ngForm" name="quickSmsForm">
                    @if (!callControlService.manualDial) {
                      <div class="mb-2">
                        <label class="slideout-label">To (Phone Number)</label>
                        <select class="slideout-select" name="numbersToSms"
                          [(ngModel)]="callControlService.numberToSendSmsTo">
                          <option [ngValue]="null">-- Select --</option>
                          <optgroup [label]="callControlService.possibleNumbersToSendSmsTo.borrowerName || '(name not set)'">
                            <option [ngValue]="callControlService.possibleNumbersToSendSmsTo.borrowerMobileNumber">
                              Mobile: {{ callControlService.possibleNumbersToSendSmsTo.borrowerMobileNumber | phone }}
                            </option>
                            <option [ngValue]="callControlService.possibleNumbersToSendSmsTo.borrowerHomeNumber">
                              Home: {{ callControlService.possibleNumbersToSendSmsTo.borrowerHomeNumber | phone }}
                            </option>
                          </optgroup>
                          @if (callControlService.possibleNumbersToSendSmsTo.coBorrowerName) {
                            <optgroup [label]="callControlService.possibleNumbersToSendSmsTo.coBorrowerName">
                              <option [ngValue]="callControlService.possibleNumbersToSendSmsTo.coBorrowerMobileNumber">
                                Mobile: {{ callControlService.possibleNumbersToSendSmsTo.coBorrowerMobileNumber | phone }}
                              </option>
                              <option [ngValue]="callControlService.possibleNumbersToSendSmsTo.coBorrowerHomeNumber">
                                Home: {{ callControlService.possibleNumbersToSendSmsTo.coBorrowerHomeNumber | phone }}
                              </option>
                            </optgroup>
                          }
                        </select>
                      </div>
                    }
                    @if (callControlService.manualDial) {
                      <div class="mb-2">
                        <label class="slideout-label">To</label>
                        <input class="slideout-input" required name="smsTo" type="text"
                          mask="(000) 000-0000" [showMaskTyped]="true"
                          #smsToInput="ngModel"
                          [ngClass]="{'is-invalid': smsToInput && (smsToInput.touched || callControlService.sendSmsClicked) && smsToInput.invalid}"
                          [(ngModel)]="callControlService.numberToSendSmsTo" />
                        <div class="invalid-feedback">This field is required</div>
                      </div>
                    }
                    <div class="mb-2">
                      <label class="slideout-label">Message</label>
                      <textarea class="slideout-input" rows="3" maxlength="255"
                        placeholder="Type your message here... (255 char limit)" name="smsBody" required
                        [(ngModel)]="callControlService.textMessage"
                        #textMessageInput="ngModel"
                        [ngClass]="{'is-invalid': textMessageInput && (textMessageInput.touched || callControlService.sendSmsClicked) && textMessageInput.invalid}">
                      </textarea>
                      <div class="char-count">{{ callControlService.textMessage?.length || 0 }} / 255</div>
                    </div>
                    <div class="invalid-feedback">This field is required</div>
                    <button class="slideout-btn slideout-btn--primary w-100" (click)="onSendSmsClicked()"
                      [disabled]="callControlService.sending || !callControlService.textMessage?.trim()">
                      @if (!callControlService.sending) {
                        <i-lucide name="send" [size]="14" [strokeWidth]="2"></i-lucide>
                        <span>Send SMS</span>
                      }
                      @if (callControlService.sending) {
                        <i-lucide name="loader-2" [size]="14" [strokeWidth]="2" class="spin"></i-lucide>
                        <span>Sending...</span>
                      }
                    </button>
                  </form>
                </div>
              }
            </div>
          </div>
        </div>

        <div class="close-panel-section mt-3">
          <button class="btn btn-sm btn-outline-secondary w-100"
            (click)="callControlService.isPanelOpened = false">
            <i class="fa fa-times me-1"></i> Close Call Panel
          </button>
        </div>
      </div>

    }

    @if (showDialpad) {
      <div class="mb-1 mt-2 dial-pad-container">
        <label class="control-label">Number to Call</label>
        <div class="d-flex">
          <input
            type="text"
            name="numberToCall"
            [(ngModel)]="numberToCall"
            mask="(000) 000-0000"
            [showMaskTyped]="true"
            class="form-control flex-grow-1"
          />
          <a class="ms-1 clear-button" (click)="onClearNumberClicked()"><span>Clear</span></a>
        </div>
      </div>
      <dialpad
        (numberClicked)="onDialpadNumberClicked($event)"
        (backspaceClicked)="onDialpadBackspaceClicked()"
        (callClicked)="onCallClicked()"
        (smsClicked)="onSmsClicked()"
        [callButtonEnabled]="numberToCall && numberToCall.length === 10"
      >
      </dialpad>
      <div class="mx-4 my-2 flex-grow-1 overflow-hidden">
        <dial-call-history
          (manualDialClicked)="numberToCall = $event; onCallClicked()"
        ></dial-call-history>
      </div>
    }
  </div>
</div>
